<template>
  <section class="policies-by-iin" v-if="policies">
    <h5 class="card-title text-gray-700 fs-5 mb-3 ms-3 text-gray-700 fw-bold">Поиск c 1c</h5>
    <div class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table
            class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800"
            style="white-space: nowrap!important;">
          <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-95px">Номер договора</th>
            <th class="w-95px">Продукт</th>
            <th>Авто</th>
            <th>Гос. номер</th>
            <th>Срок действия</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in policies" :key="key" class="align-middle">
            <td v-html="item.global"></td>
            <td>OGPO_WEB_EA</td>
            <td v-html="item.vehicles[0].mark+' '+item.vehicles[0].model"></td>
            <td>
              <span v-html="item.vehicles[0].number" class="px-2 py-1 rounded border border-gray-300 fw-bold"></span>
            </td>
            <td>
              <span class="badge badge-light-primary">{{ item.date_from }}</span> -
              <span class="badge badge-light-danger">{{ item.date_to }}</span>
            </td>
            <td class="text-end">
              <i class="ki-outline ki-right-square text-primary fs-4 cursor-pointer"
                 @click="getByGlobal(item.global)"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PoliciesByIin',
  props: {
    policies: null
  },
  data() {
    return {}
  },
  methods: {
    getByGlobal(global) {
      this.$emit('getGlobal', global)
    }
  }
}
</script>

<style></style>